var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import styled from 'styled-components';
import { designSchema } from '../../../contexts/designs/utils';
import { styledWithoutNonHTMLProps } from '../../../theme/utils';
import { propsToNotForward } from './Icon.types';
var SIZES = {
    sm: 'width: 16px; height: 16px;',
    md: 'width: 24px; height: 24px;',
    lg: 'width: 32px; height: 32px;',
    stretch: 'flex: 1; align-self: stretch;',
};
// //to use svg mask as icon, we have to use backgroundColor css property to fill svg
// //since this is transparent for the icon usage, makes more sense having the Icon component interface
// //receiving a color prop and just set as a background color here
export var StyledIcon = styledWithoutNonHTMLProps('i', propsToNotForward).attrs({
    'aria-hidden': true,
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mask-repeat: no-repeat;\n  mask-position: center;\n  mask-size: contain;\n  ", "\n  ", "};\n\n  ", ";\n  ", "\n"], ["\n  mask-repeat: no-repeat;\n  mask-position: center;\n  mask-size: contain;\n  ", "\n  ", "};\n\n  ", ";\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return size && SIZES[size];
}, function (_a) {
    var src = _a.src;
    return "mask-image: url(".concat(src, ")");
}, designSchema, function (_a) {
    var color = _a.color;
    return color && "background-color: ".concat(color, ";");
});
export var StyledImage = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return size && SIZES[size];
}, designSchema);
export var StyledDiv = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  ", ";\n  background-color: currentColor;\n  ", ";\n"], ["\n  ", "\n  ", ";\n  background-color: currentColor;\n  ", ";\n"])), function (_a) {
    var size = _a.size;
    return size && SIZES[size];
}, function (_a) {
    var src = _a.src;
    return "mask: url(".concat(src, ") no-repeat center / contain");
}, designSchema);
var templateObject_1, templateObject_2, templateObject_3;
